// extracted by mini-css-extract-plugin
export default {"box":"Robot_box__ZIEsh","imgSize":"Robot_imgSize__WPlU0"};